export default (string) => {
  const element = document.createElement('div');
  element.innerHTML = string;
  return element.innerText;
};
